import { ApiCall } from "../../utils";
import { GET_ALL_BOOKINGS_VALUE, GET_SALES_ORDER } from "../constants";

export const getSalesOrderData =
  (
    request,
    page,
    debouncedHandleSearch,
    sortOrder,
    sortField,
    rowsPerPage,
    status
  ) =>
  async (dispatch, getState) => {
    try {
      const {
        auth: { token },
      } = getState();
      const searchParam = debouncedHandleSearch
        ? `search=${debouncedHandleSearch}`
        : "";
      const result = await ApiCall.get(
        `/sales_order?${searchParam}&sort_field=${sortField}&sort_order=${sortOrder}&page=${page}&page_size=${rowsPerPage}&status=${JSON.stringify(
          status
        )}`,
        token
      );
      request.onSuccess(result);
      dispatch({ type: GET_SALES_ORDER, payload: result.data });
    } catch (error) {
      request.onError(error);
    }
  };

export const addSalesOrderData = (request) => async (dispatch, getState) => {
  try {
    const {
      auth: { token },
    } = getState();
    const result = await ApiCall.post("/sales_order", request.payload, token);
    request.onSuccess(result);
  } catch (error) {
    request.onError(error);
  }
};

export const updateSaleOrderData = (request) => async (dispatch, getState) => {
  try {
    const {
      auth: { token },
    } = getState();
    const result = await ApiCall.patch(
      `/sales_order/${request.sales_order_id}`,
      request.payload,
      token
    );
    request.onSuccess();
  } catch (error) {
    request.onError(error);
  }
};

export const deleteSalesOrderData = (request) => async (dispatch, getState) => {
  try {
    const {
      auth: { token },
    } = getState();
    const result = await ApiCall.delete(
      `/sales_order/${request.sales_order_id}`,
      token
    );
    request.onSuccess();
  } catch (error) {
    request.onError(error);
  }
};


export const uploadOrderFile =
  (order_type, order_id, payload, cb) => async (dispatch, getState) => {
  try {
    const {
      auth: { token, company },
    } = getState();
    const result = await ApiCall.postFormData(
      `/sales_order/file_upload/${order_type}/${order_id}`,
      payload,
      token
    );
    cb(result);
  } catch (error) {
    cb(error);
  }
};


export const getTemplateValuesByOrderId =
  (order_id, cb) => async (dispatch, getState) => {
  try {
    const {
      auth: { token },
    } = getState();
    const result = await ApiCall.get(
      `/sales_order/template_values/${order_id}`,
      token
    );
    dispatch({
      type: GET_ALL_BOOKINGS_VALUE,
      payload: result.data,
    });
    cb(result);
  } catch (err) {
    cb(err);
  }
};
